import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'pay-login-lost-mfa-email-sent',
  imports: [TranslatePipe],
  templateUrl: './lost-mfa-email-sent.component.html',
})
export class LostMfaEmailSentComponent {
  private readonly _router = inject(Router);

  returnToLogin() {
    this._router.navigateByUrl('/').then();
  }
}
